import { Component, OnDestroy } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { AuthService, ISignupParamsModel } from '@thinglogix/ngx-foundry-core';
import { Subject } from 'rxjs';
import { LiValidators } from 'src/app/shared/forms/validators';
import { environment } from 'src/environments/environment';

const MIN_LENGTH = 3;
const MIN_PASSWORD_LENGTH = 8;
const PHONE_NUMBER_LENGTH = 14;

@Component({
    selector: 'li-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.sass'],
})
export class SignupComponent implements OnDestroy {
    isLoader = false;

    phoneNo = '';

    isLoadingMode = true;

    sucessClass = '';

    sucessClassAdd = '';

    //we are checking maxlength , white space and blank value on this validation

    readonly NoWhitespaceRegExp: RegExp = new RegExp('\\S');

    readonly onlyNumbersRegex =
        /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.]\d{3}[\s.]\d{4}$/;

    signupForm: FormGroup = this.fb.group(
        {
            companyName: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.NoWhitespaceRegExp),
                    Validators.minLength(MIN_LENGTH),
                ],
            ],
            phoneNumber: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.onlyNumbersRegex),
                    Validators.minLength(PHONE_NUMBER_LENGTH),
                    Validators.maxLength(PHONE_NUMBER_LENGTH),
                ],
            ],
            firstName: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.NoWhitespaceRegExp),
                    Validators.minLength(MIN_LENGTH),
                    this.noNumbersValidator(),
                ],
            ],
            lastName: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.NoWhitespaceRegExp),
                    Validators.minLength(MIN_LENGTH),
                    this.noNumbersValidator(),
                ],
            ],
            email: [
                '',
                [
                    Validators.required,
                    Validators.email,
                    Validators.pattern(this.NoWhitespaceRegExp),
                ],
            ],
            username: [
                '',
                [
                    Validators.required,
                    Validators.pattern(this.NoWhitespaceRegExp),
                    Validators.minLength(MIN_LENGTH),
                ],
            ],
            password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(MIN_PASSWORD_LENGTH),
                ],
            ],
            confirm_password: [
                '',
                [
                    Validators.required,
                    Validators.minLength(MIN_PASSWORD_LENGTH),
                ],
            ],
            option1: ['', [Validators.requiredTrue]],
        },
        {
            validator: LiValidators.mustMatch('password', 'confirm_password'),
        }
    );

    noNumbersValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const noNumbersRegExp = /^\D+$/;
            const value = control.value;
            const hasNumbers = noNumbersRegExp.test(value);
            return hasNumbers ? null : { containsNumber: true };
        };
    }

    private ngUnsubscribe = new Subject();

    errorMsg = '';

    constructor(private fb: FormBuilder, private authService: AuthService) {
        this.signupForm.valueChanges.subscribe(console.log);
    }

    /**
     * This function phone is returning no in the US format
     *
     * @param val : (XXX) XXX XXXX
     */

    validationCheck(val: any) {
        const x: string = val
            .replace(/\D/g, '')
            .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

        const second = 2;
        const third = 3;

        this.phoneNo =
            `(${x[1]}` +
            (x[1] ? `) ${x[second]}` : '') +
            (x[second] ? ` ${x[third]}` : '');
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(undefined);
        this.ngUnsubscribe.complete();
    }
    /**
     * Calls the signup API using the form value
     *
     * @returns Promise<void> Promise with void value after the API has been called
     */

    async signup(): Promise<void> {
        const signupFormValue = this.signupForm.value;
        const companyName = signupFormValue.companyName.trim();
        const phoneNumber = signupFormValue.phoneNumber.trim();
        const firstName = signupFormValue.firstName.trim();
        const lastName = signupFormValue.lastName.trim();
        const email = signupFormValue.email.trim();
        const username = signupFormValue.username.trim();
        const password = signupFormValue.password.toString();
        const option1 = signupFormValue.option1.toString();

        const signupPayload: ISignupParamsModel = {
            user: {
                phone: phoneNumber,
                api_user_only: 0, // 1 if they are only an API user
                first_name: firstName,
                last_name: lastName,
                email: email,
                host: `${window.location.origin}/auth`,
                password: password,
                role: 'User',
                username: username,
                policy_type: option1,
                password_type: 1,
            },
            account: {
                name: companyName,
                phone_number: phoneNumber,
                password_policy: this.authService.passwordPolicies[0].regex,
                parent_id: environment.liquidInsightAccountId,
            },
        };
        this.isLoader = true;
        this.errorMsg = '';
        this.authService

            .signUp(environment.liquidInsightAccountId, signupPayload)
            .subscribe(
                () => {
                    //Success Response
                    this.isLoader = false;
                    this.sucessClass = 'tabcontentRemove';
                    this.sucessClassAdd = 'tabcontentadd';
                },
                (error) => {
                    //Error Response
                    this.isLoader = false;
                    this.errorMsg = error.error['error'];
                }
            );
    }
}
